import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { SiteRevenueView } from '@/features/site/components/revenue/SiteRevenueView'
import { SiteRevenueLegacyView } from '@/features/site/pages/components/SiteRevenueLegacyView'
import type { MarketProgram } from '@/features/site/types/marketProgram'
import type { InsightRevenuePeriod, RevenuePeriod } from '@/features/site/types/revenue'
import type { Site } from '@/features/site/types/site'

type SiteRevenueContentProps = {
  site: Site
  insightRevenuePeriods: InsightRevenuePeriod[]
  legacyRevenuePeriods: RevenuePeriod[] | null
  marketPrograms: MarketProgram[] | null
  hasRevenueData: boolean
  hasLegacyData: boolean
}

export function SiteRevenueContent({
  site,
  insightRevenuePeriods,
  legacyRevenuePeriods,
  marketPrograms,
  hasRevenueData,
  hasLegacyData,
}: Readonly<SiteRevenueContentProps>) {
  const { t } = useTranslation()

  if (hasRevenueData) {
    return <SiteRevenueView revenuePeriods={insightRevenuePeriods} site={site} />
  }

  if (hasLegacyData) {
    return <SiteRevenueLegacyView marketPrograms={marketPrograms} revenuePeriods={legacyRevenuePeriods} site={site} />
  }

  return (
    <Typography align="center" sx={{ m: 4 }}>
      {t('customer_revenue.no_revenue_data')}
    </Typography>
  )
}
